import React from 'react';
import { LegalPage } from '../components/LegalPage';

const Terms = () => (
  <LegalPage
    testId="terms-page"
    eyebrow="Legal"
    title="Terms & Conditions"
    updated="July 2026"
  >
    <p>
      These Terms &amp; Conditions ("Terms") govern your use of the Luggage Free Journey
      website, mobile app, and doorstep luggage pickup &amp; delivery service (collectively,
      the "Service"). By booking a pickup, you agree to these Terms in full. Please read
      them carefully.
    </p>

    <h2>1. The service</h2>
    <p>
      Luggage Free Journey provides door-to-door pickup and delivery of personal
      luggage within the cities we operate in. We accept sealed bags of up to 30 kg
      per piece, sized within standard airline check-in dimensions.
    </p>

    <h2>2. Booking &amp; payment</h2>
    <ul>
      <li>Bookings are confirmed only after successful payment via Razorpay (UPI, card, or net-banking).</li>
      <li>Prices displayed at the time of booking are inclusive of applicable taxes.</li>
      <li>Edits that raise the total require a top-up payment before the pickup window opens; edits that reduce the total create a pending refund reviewed by our admin team.</li>
    </ul>

    <h2>3. Prohibited items</h2>
    <p>The following items must <strong>never</strong> be handed to our agents:</p>
    <ul>
      <li>Cash, jewellery, precious metals, currency notes, share/bond certificates.</li>
      <li>Flammables, explosives, aerosols, lithium batteries loose in the bag, compressed gases.</li>
      <li>Live animals, perishable food, human remains.</li>
      <li>Narcotics, contraband, illegal substances, weapons or ammunition.</li>
      <li>Items whose export/import/transport is restricted by law.</li>
    </ul>
    <p>
      Handing over a prohibited item voids all insurance cover, may result in
      confiscation, and may be reported to law enforcement.
    </p>

    <h2 id="insurance" style={{ scrollMarginTop: '80px' }}>4. Liability &amp; insurance</h2>
    <ul>
      <li>Every booking is auto-insured up to <strong>₹10,000</strong> per bag against loss or damage during transit.</li>
      <li>You may declare a higher value at booking; additional cover is charged per bag.</li>
      <li>Our liability is capped at the declared value or ₹10,000, whichever is lower.</li>
      <li>Claims must be raised within <strong>24 hours</strong> of delivery via email to support, with photos and the baggage tag reference.</li>
    </ul>

    <h2>5. Delivery, delays &amp; OTP</h2>
    <p>
      Standard inter-city delivery windows are 24–48 hours; intra-city is usually same-day.
      Every drop-off requires OTP verification from the recipient's registered mobile. If
      the OTP holder is unavailable, the bag returns to the nearest hub and a redelivery
      is scheduled at no extra cost — for up to two attempts. Any further attempts incur a
      re-delivery fee.
    </p>
    <p>
      If a delivery is delayed by more than 24 hours due to our operational fault, a
      partial refund is auto-issued to your original payment method.
    </p>

    <h2 id="refund" style={{ scrollMarginTop: '80px' }}>6. Cancellation &amp; refunds</h2>
    <ul>
      <li>Cancellations <strong>before</strong> pickup: 100% refund minus any payment gateway fee.</li>
      <li>Cancellations <strong>after</strong> pickup but before delivery: 50% refund; the bag is returned to origin.</li>
      <li>Refunds are credited to the original payment method within 5–10 business days.</li>
      <li>Detailed policy: see our <a href="/policies">Company Policies</a> page.</li>
    </ul>

    <h2>7. Customer responsibilities</h2>
    <ul>
      <li>Ensure the bag is securely locked and each zip lock is functional at pickup.</li>
      <li>Provide accurate pickup and delivery addresses, including landmarks and pincodes.</li>
      <li>Be available (or nominate someone) to hand over the bag and share the delivery OTP.</li>
      <li>Do not include any item listed under Section 3 (Prohibited items).</li>
    </ul>

    <h2>8. Force majeure</h2>
    <p>
      We are not liable for delays or non-performance caused by events beyond our
      reasonable control — including but not limited to natural disasters, strikes,
      civil unrest, transport blockades, or government orders. In such events we
      will make reasonable efforts to complete the delivery or issue a refund.
    </p>

    <h2>9. Governing law &amp; jurisdiction</h2>
    <p>
      These Terms are governed by the laws of India. Any dispute arising out of
      the Service shall be subject to the exclusive jurisdiction of the courts at
      Bangalore, Karnataka.
    </p>

    <h2>10. Changes to these terms</h2>
    <p>
      We may update these Terms from time to time. Material changes will be
      notified via WhatsApp/SMS to registered customers at least 7 days before
      they take effect. Continued use of the Service after the effective date
      constitutes acceptance of the revised Terms.
    </p>

    <p style={{ marginTop: '2rem', color: '#737373', fontSize: '0.85rem' }}>
      Questions? Write to <a href="mailto:support@luggagefreejourney.com">support@luggagefreejourney.com</a>.
    </p>
  </LegalPage>
);

export default Terms;
